import React, { useState } from 'react';
import { Col, Row } from 'antd';
import StandardCard from '../StandardCard/StandardCard';
import FileDetail from '../FileDetail/FileDetail';

export default function CardGroup({ files = [], title }) {
  const [isShow, setIsShow] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(-1);
  return (
    <div className='singular-row'>
      <Row gutter={[20, 20]}>
        {
          // 遍历组中的每个文件
          files.map((file, index) => (
            <Col
              key={file.id}
              span={6}
            >
              <StandardCard
                file={file}
                mark={index}
                isShow={isShow}
                currentIndex={currentIndex}
                updateIndex={setCurrentIndex}
                updateIsShow={setIsShow}
                title={title}
              />
            </Col>
          ))
        }
      </Row>
      {isShow && <FileDetail data={files[currentIndex]} />}
    </div>
  );
}
